import base64 from "base-64";
import utf8 from "utf8";
import queryString from "query-string";

export const DEFAULT_OOBABOOGA_SETTINGS = {
  temp: 0.7,
  maxTokens: 100,
  topP: 0.9,
  topK: 0,
  typicalP: 1,
  repetitionPenalty: 1.1,
  encoderRepitionPenalty: 1,
  noRepeatNgramSize: 0,
  minLength: 0,
  doSample: true,
  seed: -1,
  penaltyAlpha: 0,
  numBeams: 1,
  lengthPenalty: 1,
  earlyStopping: false,
  addBosToken: true,
  banEosToken: false,
  truncateLength: 2048,
  stoppingStrings: "\nAnon:",
  skipSpecialTokens: true,
};

export const DEFAULT_KOBOLDAI_SETTINGS = {
  maxContextLength: 4096,
  maxTokens: 60,
  temp: 0.6,
  topP: 0.9,
  topK: 40,
  topA: 0.9,
  tailFreeSampling: 0.6,
  typicalP: 0.95,
  repetitionPenalty: 1.0,
  repetitionPenaltyRange: 512,
  repetitionPenaltySlope: 3.0,
  order: [0, 1, 2, 3, 4],
};

const ALPHA_URL = "https://alpha.miku.gg";

export const DEFAULT_OPENAI_SETTINGS = {
  oaiModel: "gpt-3.5-turbo",
  temp: 0.8,
  frequencyPenalty: 0.0,
  presencePenalty: 0.0,
  topP: 1.0,
};

export function generateAlphaLink(botHash) {
  return `${ALPHA_URL}/?cardId=${botHash}`;
}
